import { sentenceItem } from "../models/interfaces";

export const getRowColor = (sentence: sentenceItem) => {
  
  let color = 'black';
  // const numberValue = parseInt(confidence);
  // switch (true) {
  //   case !sentence.burden &&
  //     sentence.predicted_label_language === 'ComplianceLanguage':
  //     color = '#FFBF00';
  //     break;
  //   case sentence.burden &&
  //     sentence.predicted_label_language === 'GeneralLanguage':
  //     color = '#FFBF00';
  //     break;
  //   case sentence.burden &&
  //     sentence.predicted_label_language === 'ComplianceLanguage':
  //     color = '#FF0000';
  //     break;
  //   default:
  //     color = '#000000';
  //     break;
  // }
  switch (true) {
    // case !sentence.burden &&
    //   sentence.predicted_label_language === 'ComplianceLanguage':
    //   color = '#FFBF00';
    //   break;
    case sentence.type === 'Expectation':
      color = '#FFBF00';
      break;
    case sentence.type === 'Obligation':
      color = '#FF0000';
      break;
    default:
      color = '#000000';
      break;
  }
  return color;
}